import { useParams } from 'react-router-dom';
import { getUser } from 'services';
import styled from 'styled-components';

import { Box, FlexColumn, FlexContainer, Image, Text } from '../../../../shared/Typhography';

import { RevenueTable } from './Components';

const Container = styled.div`
  margin-top: 150px;
`;

export default function ArtistInsightsScreen() {
  const { artistId } = useParams<{ artistId: string }>();
  const { data: artist, isLoading } = getUser(artistId);

  return (
    <Container>
      <Box style={{ marginBottom: '20px' }}>
        {!isLoading && (
          <FlexContainer flexWrap="wrap">
            <Image
              cursor="pointer"
              src={artist?.data()?.profileImageUrl}
              borderRadiusType="circle"
              size="insightsThumbnail"
              alt="Picture"
              margin={{ right: '80px' }}
            />
            <FlexColumn alignItems="flex-start">
              <Text size={2.5} margin="0 0 5px 0">
                {artist?.data()?.Name}
              </Text>
              <FlexContainer justifyContent="space-between" margin="0 0 20px 0">
                <Text size={1} color="#7B828A">
                  {artist?.data()?.username ? `@${artist?.data()?.username}` : ''}
                </Text>
              </FlexContainer>
            </FlexColumn>
          </FlexContainer>
        )}
      </Box>
      {/* <Box> <RevenueGraphs /> </Box> */}
      <Box>
        <RevenueTable />
      </Box>
    </Container>
  );
}
